import { render, staticRenderFns } from "./WellbeingStudioV2.vue?vue&type=template&id=77219cbd"
import script from "./WellbeingStudioV2.vue?vue&type=script&lang=js"
export * from "./WellbeingStudioV2.vue?vue&type=script&lang=js"
import style0 from "./WellbeingStudioV2.vue?vue&type=style&index=0&id=77219cbd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports